import React, { Component } from 'react';
import { Card, Table, Input, Row, Col, Button } from 'antd';
import { Getcategories } from '../../../api';
import { PAGE_SIZE } from '../../../utils/constants';
import LinkButton from '../../../components/link-button';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Tag } from 'antd';

export default class UserHome extends Component {
  constructor(props) {
    super(props);
    // 初始化状态
    this.state = {
      users: [], // 用户列表数据
      total: '', // 用户总数
      currentPage: 1, // 当前页码
      searchName: '', // 查询的名称
    };
    // 表格列配置
    this.columns = [
      {
        title: '序号',
        dataIndex: 'index',
        render: (text, record, index) => {
          // 计算序号
          let number =
            ((this.state.currentPage || 1) - 1) * PAGE_SIZE + (index + 1);
          return number;
        },
        align: 'center',
      },
      {
        title: 'id',
        dataIndex: 'id',
        align: 'center',
      },
      {
        title: '名称',
        dataIndex: 'name',
        align: 'center',
        render: (text, record) => record.name.cn, // 访问cn数据
      },
      {
        title: '状态',
        dataIndex: 'state',
        align: 'center',
        render: text => {
          return text === 'enabled' ? (
            <Tag color="green" icon={<CheckCircleOutlined />}>已启用</Tag>
          ) : (
            <Tag color="red" icon={<CloseCircleOutlined />}>未启用</Tag>
          );
        },
      },
      {
        title: '操作',
        render: user => (
          <span>
            {/* 用户详情链接 */}
            <LinkButton
              onClick={() =>
                this.props.history.push('/admin/category/detail', user)
              }
            >
              详情
            </LinkButton>
          </span>
        ),
        align: 'center',
      },
    ];
  }

  // 获取用户列表数据
  Getcategories = async (pagination, name = '') => {
    const data = {
      pageNumber: pagination,
      pageSize: PAGE_SIZE,
      verbose: '100',
    };
    if (name) {
      data.name = name; // 如果有name参数，则使用name进行查询
    }
    const res = await Getcategories(data);
    if (res.status === 200) {
      const { result, total } = res;
      // 更新状态
      this.setState({
        users: result,
        total,
        currentPage: pagination, // 更新当前页码
      });
    }
  };

  // 处理页码变化
  handlePagination = pagination => {
    // 获取当前查询条件
    const { searchName } = this.state;
    // 查询指定页码的数据
    this.Getcategories(pagination, searchName);
  };

  // 处理输入框变化
  handleInputChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  // 组件挂载时获取用户数据
  componentDidMount() {
    this.Getcategories(1); // 初始获取全部数据
  }

  // 处理重置
  handleReset = () => {
    this.setState({ searchName: '' }); // 清空查询条件
    this.Getcategories(1); // 获取全部数据
  };

  render() {
    const { users, total, currentPage, searchName } = this.state;
    // 查询输入框
    const extra = (
      <Row gutter={16}>
        <Col>
          <Input
            placeholder='查询名称'
            name='searchName'
            value={searchName}
            onChange={this.handleInputChange}
          />
        </Col>

        <Col>
          <Button
            type='primary'
            onClick={() => this.Getcategories(1, searchName)} // 指定查询条件和页码
          >
            查询
          </Button>
        </Col>

        <Col>
          <Button
            type='primary'
            onClick={this.handleReset} // 点击重置按钮
          >
            重置
          </Button>
        </Col>

        <Col>
          <Button
            type='primary'
            onClick={() => this.props.history.push('/admin/category/detail')}
          >
            添加
          </Button>
        </Col>
      </Row>
    );
    return (
      <Card extra={extra}>
        {/* 用户列表表格 */}
        <Table
          bordered
          rowKey='id'
          dataSource={users}
          columns={this.columns}
          pagination={{
            showSizeChanger: false,
            defaultPageSize: 10,
            total,
            showTotal: total => {
              return `共 ${total} 条`;
            },
            onChange: this.handlePagination,
            current: currentPage,
          }}
        />
      </Card>
    );
  }
}
